import React from 'react'
import { SvgIconProps } from '@mui/material'
import Face from '@mui/icons-material/Face'
import Face3 from '@mui/icons-material/Face3'
import Person from '@mui/icons-material/Person'
import { PatientGender } from '@/shared/types/yakurekiCore'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

interface PatientGenderIconProps extends SvgIconProps {
  gender?: PatientGender
}

const PatientGenderIcon: React.FC<PatientGenderIconProps> = ({
  gender,
  ...props
}) => {
  // スケール定数を定義
  const FEMALE_ICON_SCALE = 0.95

  // デフォルトの色設定
  const defaultColors = {
    male: colorTokens.special.genderMale, // メインブルー（既存デザインシステムと一致）
    female: colorTokens.special.genderFemale, // 淡いピンク（UIに馴染む落ち着いた色調）
    other: colorTokens.grey[500], // 無効状態のグレー（紫からグレーに変更）
    default: colorTokens.text.secondary, // マジックナンバーを定数化
  }

  const color =
    props.color || (gender ? defaultColors[gender] : defaultColors.default)

  if (gender === 'female') {
    return (
      <Face3
        {...props}
        sx={{ color, transform: `scale(${FEMALE_ICON_SCALE})`, ...props.sx }}
      />
    )
  }
  if (gender === 'other') {
    return <Person {...props} sx={{ color, ...props.sx }} />
  }
  // デフォルト（男性）
  return <Face {...props} sx={{ color, ...props.sx }} />
}
export default PatientGenderIcon
